export default {
  AvailableStartTime: 'Available StartTime',
  AvailableStartTimeMin: 'Available StartTime Min',
  AvailableStartTimeMax: 'Available StartTime Max',
  AvailableExpireTime: 'Available ExpireTime',
  AvailableExpireTimeMin: 'Available ExpireTime Min',
  AvailableExpireTimeMax: 'Available ExpireTime Max',
  CashAmount: 'Cash Amount',
  CashAmountMin: 'Cash Amount Min',
  CashAmountMax: 'Cash Amount Max',
  CommandNumber: 'Command Number',
  CommandTime: 'Command Time',
  CommandTimeMin: 'CommandTime Min',
  CommandTimeMax: 'CommandTime Max',
  Enabled: 'Enabled',
  GiftAmount: 'Gift Amount',
  GiftAmountMin: 'Gift Amount Min',
  GiftAmountMax: 'Gift Amount Max',
  GiftCards: 'GiftCards',
  MaximumUse: 'Maximum Use',
  MaximumUseMin: 'Maximum Use Min',
  MaximumUseMax: 'Maximum Use Max',
  Organization: 'Organization',
  Title: 'Title',
  Pin: 'Pin',
  PinLength: 'Pin Length',
  Quantity: 'Quantity',
  ShowAndroid: 'show Android',
  ShowIOS: 'show IOS',
  ShowWeb: 'show Web',
  ShowWebService: 'show WebService',
  SortOrder: 'SortOrder',
  ShowOn: 'Show On',
  Slug: 'Slug',
  Used: 'Used',
  giftCardType: 'gift card type',
  giftCards: 'Gift cards',

  availableStartTime: 'Available startTime',
  availableExpireTime: 'Available expireTime',
  pinLength: 'Pin length'
}
